import image from "@/assets/holiday-cards/holiday-card-rootree-radio.png";
import { DayDefinition } from "../DayDefinition.js";
import { Players } from "../shared/Players.js";

/**
 * Class Rootree_Radio
 *
 * Represents the Rootree Radio card.
 */
export class Rootree_Radio extends DayDefinition {
	/** The CSS class to use for the card. */
	public className = "hl:bg-darkbrown2022";
	public image = image;
	/** The slug for the card. Used to identify the card for css, etc. */
	public slug = "rootree-radio";

	/** Get the display for the card in English. */
	public initENCard(): void {
		this.title = "Rootree Radio";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`If you're thinking all I want for Christmas is a brand-new playlist.
					Well follow us on Spotify and allow us to assist.
					Filled with holiday bops, and classic old tunes.
					For more than driving home from work on snowy afternoons.
					Of course, `}
					<em>Rootree Radio</em>
					{` has some great non-holiday songs.
					For winter dinner parties, focus fuel, and family singalongs.`}
				</p>
				<br />
				<Players lists={["2cirvtV28bKqfvzmyz6utx", "0L1DjGGB7LudWAKeAwJaY2"]} />
			</>
		);
	}

	/** Get the display for the card in French. */
	public initFRCard(): void {
		this.title = "Radio Rootree";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`Si vous vous dites «pour Noël, je veux une nouvelle playlist»,
					Suivez-nous sur Spotify et laissez-nous nous occuper de la suite.
					Des tubes de vacances et ou de vieux standards
					Pour rentrer du travail s’il neige et qu’il est tard.
					Bien sûr, `}
					<em>Rootree Radio</em>
					{` propose aussi d’autres chansons à écouter en-dehors des vacances,
					Pratique pour les dîners d’hiver s’il faut pousser la chansonnette en famille ou se mettre à la danse.`}
				</p>
				<br />
				<Players lists={["2cirvtV28bKqfvzmyz6utx", "0L1DjGGB7LudWAKeAwJaY2"]} />
			</>
		);
	}
}
